<template>
  <div>
    <div ref='piechart' class='echartbox' :style="{width: chartWidth,height: chartHeight}">
    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
// 引入饼图组件
require("echarts/lib/chart/pie");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
export default {
  name: "pie",
  props: {
    // tite: "", //图名
    piedata: [Object, Array],
    name: String,
    // title:{
    //   type: [String, String],
    //   default: ""
    // },
    legend: Object,
    chartWidth: {
      type: [String, Number],
      default: "500px"
    },
    chartHeight: {
      type: [String, Number],
      default: "200px"
    },
    chartColor: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      title: "",
      legend_data: [],
      series_data: []
    };
  },
  mounted() {
    this.initChart();
  },
  watch: {
    piedata: {
      handler() {
        this.initChart();
      },
      deep: true
    }
  },
  methods: {
    initChart() {
      let datas = [];
      if (Object.prototype.toString.call(this.piedata) == "[object Array]") {
        datas = this.piedata;
      } else {
        const keyArray = this.piedata.columns;
        this.piedata.rows.forEach(item => {
          datas.push({
            value: item[keyArray[1]],
            name: item[keyArray[0]]
          });
        });
      }
      const initCharts = echarts.init(this.$refs.piechart);
      const chartColor = this.chartColor.length === 0 ? null : this.chartColor;

      const options = {
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        title: this.title,
        legend: this.legend,
        series: {
          name: this.name,
          type: "pie",
          radius: "55%",
          data: datas,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            },
            color: chartColor
          }
        }
      };

      initCharts.setOption(options);
    }
  }
};
</script>
